import { PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';

interface PopoverMenuItemsProps<T> {
  data: T[];
  renderItem: (item: T) => React.ReactNode;
  keyGen: (item: T) => string;
  getItemProps: ReturnType<typeof usePopoverMenu>['getItemProps'];
  onClickItem: (item: T) => void;
  trackingId?: (item: T) => string;
  canRender?: (item: T) => boolean;
}

export const PopoverMenuItems = <T,>({
  data,
  renderItem,
  keyGen,
  getItemProps,
  onClickItem,
  canRender = () => true,
  trackingId,
  ...rest
}: PopoverMenuItemsProps<T>) => {
  return data.map((item) => {
    const show = canRender(item);

    if (show)
      return (
        <PopoverMenuItem
          key={keyGen(item)}
          trackingId={trackingId ? trackingId(item) : ''}
          {...getItemProps()}
          onClick={() => onClickItem(item)}
          {...rest}
        >
          {renderItem(item)}
        </PopoverMenuItem>
      );
    return null;
  });
};

PopoverMenuItems.displayName = 'PopoverMenuItems';
